/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSnackbarNotificationStyles = makeStyles({
  root: {
    minWidth: '310px',
    display: 'flex',
    border: '1px solid #EEEEEE',
    maxWidth: 'calc(100% - 32px)',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
  },
  noVariantOffset: {
    paddingLeft: '16px',
  },
  icon: {
    padding: '14px 7px 0 16px',
    flex: '0 0 auto',
  },
  successIcon: {
    color: '#35B44E',
  },
  errorIcon: {
    color: '#FA634E',
  },
  infoIcon: {
    color: '#A2A7AE',
  },
  warningIcon: {
    color: '#F7B500',
  },
});
